<template>
  <div class="playButton" v-html="textSpan">

  </div>
</template>

<script>
export default {
name: "PlayButton",
  data(){
    return{
      textSpan:'play'
    }
  },
  created() {
    this.textSpan = this.textSpan.replace(/\S/g, "<span class='letter'>$&</span>")
  }
}
</script>

<style>
.playButton{
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
}

.letter{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
  font-size: 17px;
  letter-spacing: 5px;
  border-radius: 10px;
  margin: 5px;
  background-color: #e2e2e2;
  text-transform: uppercase;
  box-shadow:var(--insets);
  transition: all .3s ease-in-out;
}

.letter:hover{
  box-shadow: none;
  text-shadow: 5px 5px 3px #515151;
}
</style>